/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publish_Searchversions1Inputs */

const zh_publish_searchversions1 = /** @type {(inputs: Publish_Searchversions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索版本...`)
};

const en_publish_searchversions1 = /** @type {(inputs: Publish_Searchversions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search versions...`)
};

const es_publish_searchversions1 = /** @type {(inputs: Publish_Searchversions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar versiones...`)
};

/**
* | output |
* | --- |
* | "Search versions..." |
*
* @param {Publish_Searchversions1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const publish_searchversions1 = /** @type {((inputs?: Publish_Searchversions1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Searchversions1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_publish_searchversions1(inputs)
	if (locale === "en") return en_publish_searchversions1(inputs)
	return es_publish_searchversions1(inputs)
});
export { publish_searchversions1 as "publish_searchVersions" }